export default __webpack_public_path__ + "static/media/006-champagne.4a425826.svg";